"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmInputText = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const input_1 = require("../FieldControl/input");
const field_1 = require("../FieldControl/field");
const button_1 = require("../FieldControl/button");
exports.SmInputText = (0, react_1.forwardRef)((_a, ref) => {
    var { id, label, message, invalid, disabled, icon, iconLabel, srOnly, onIconClick, children } = _a, props = __rest(_a, ["id", "label", "message", "invalid", "disabled", "icon", "iconLabel", "srOnly", "onIconClick", "children"]);
    const inputClassnames = (0, classnames_1.default)({ 'pr-9': icon }, props.className);
    return (react_1.default.createElement(field_1.SmFieldTemplate, { id: id, type: "text", label: label, disabled: disabled, invalid: invalid, message: message, srOnly: srOnly },
        react_1.default.createElement(input_1.SmInputTemplate, Object.assign({}, props, { id: id, ref: ref, type: "text", message: message, invalid: invalid, disabled: disabled, className: inputClassnames })),
        icon && (react_1.default.createElement(button_1.SmInputButtonTemplate, { onClick: (e) => {
                onIconClick === null || onIconClick === void 0 ? void 0 : onIconClick(e);
            }, title: iconLabel, icon: icon })),
        children));
});
//# sourceMappingURL=index.js.map